{
  "name": "adey-installers-club-web-app",
  "version": "6.0.1",
  "license": "UNLICENSED",
  "scripts": {
    "ng": "node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng",
    "serve": "npm run ng serve",
    "serve:local": "npx ng serve -c local",
    "serve:test": "npm run ng serve -c test",
    "serve:production": "npm run ng serve -c production",
    "build": "npx ng build",
    "test": "ng test",
    "test:ci": "ng test --watch=false --code-coverage --progress=false --browsers=ChromeHeadlessNoSandbox",
    "lint": "ng lint",
    "lint:report": "ng lint --format checkstyle --output-file lint-results.xml --force && ng lint --format json --output-file lint-results.json --force",
    "lint:fix": "ng lint --fix",
    "build:test": "node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng build -c test",
    "build:production": "node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng build -c production",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org behold --project adey-web-portal ./dist && sentry-cli --url https://sentry.behold.dev/ sourcemaps upload --org behold --project adey-web-portal ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.14",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.14",
    "@angular/compiler": "^18.2.14",
    "@angular/core": "^18.2.14",
    "@angular/forms": "^18.2.14",
    "@angular/material": "^18.2.14",
    "@angular/platform-browser": "^18.2.14",
    "@angular/platform-browser-dynamic": "^18.2.14",
    "@angular/platform-server": "^18.2.14",
    "@angular/router": "^18.2.14",
    "@angular/service-worker": "^18.2.14",
    "@ngrx/effects": "^18.1.1",
    "@ngrx/entity": "^18.1.1",
    "@ngrx/operators": "^18.0.0",
    "@ngrx/store": "^18.1.1",
    "@ngrx/store-devtools": "^18.1.1",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@sentry/angular": "^10.49.0",
    "@sentry/cli": "^2.58.5",
    "@tinymce/tinymce-angular": "^7.0.0",
    "angular-calendar": "^0.31.0",
    "angular-datatables": "^15.0.1",
    "bootstrap": "^3.3.7",
    "chart.js": "^2.9.4",
    "datatables.net": "^1.11.3",
    "datatables.net-dt": "^1.11.3",
    "date-fns": "1.30",
    "export-to-csv": "^0.2.1",
    "file-saver": "^1.3.3",
    "font-awesome": "^4.7.0",
    "intl": "^1.2.5",
    "jquery": "^3.4.1",
    "karma-cli": "^2.0.0",
    "material-design-icons": "^3.0.1",
    "moment": "^2.29.4",
    "ngx-clipboard": "^15.1.0",
    "rxjs": "^6.6.7",
    "tinymce": "^5.10.9",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.21",
    "@angular/cli": "^18.2.21",
    "@angular/compiler-cli": "^18.2.14",
    "@angular/language-service": "^18.2.14",
    "@types/datatables.net": "^1.10.12",
    "@types/jasmine": "~3.10.0",
    "@types/jasminewd2": "~2.0.2",
    "@types/jquery": "^3.3.33",
    "@types/node": "^12.11.1",
    "angular-eslint": "18.4.3",
    "core-js": "^3.32.2",
    "eslint": "^9.15.0",
    "eslint-formatter-checkstyle": "^9.0.1",
    "jasmine-core": "~3.99.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.4",
    "ts-node": "~3.3.0",
    "typescript": "5.4.5",
    "typescript-eslint": "8.16.0"
  }
}